module.exports = __webpack_public_path__ + "img/CCLF_infographic-03.1f357221.png";